export const mutations = {
  user_id(state, value) {
    state.user_id = value;
  },
  user_full_name(state, value) {
    state.user_full_name = value;
  },
  current_view(state, value) {
    state.current_view = value;
  },
  current_view_parent(state, value) {
    state.current_view_parent = value;
  },
  currency(state, value) {
    state.currency = value;
  },
  permissions(state, value) {
    state.permissions = value;
  },
  role(state, value) {
    state.role = value;
  },
  role_display(state, value) {
    state.role_display = value;
  },
  use_fiscal(state, value) {
    state.use_fiscal = value;
  },
  company_name(state, value) {
    state.company_name = value;
  },
  cashes(state, value) {
    state.cashes = value;
  },

  set_access_token(state, value) {
    state.access_token = value;
    localStorage.setItem("access_token", value);
  },
  set_refresh_token(state, value) {
    state.refresh_token = value;
    localStorage.setItem("refresh_token", value);
  },
  delete_access_token(state) {
    state.access_token = '';
    localStorage.setItem("access_token", '');
  },
  delete_refresh_token(state) {
    state.refresh_token = '';
    localStorage.setItem("refresh_token", '');
  },

  // repeat_request_config(state, value) {
  //   state.repeat_request_config = value;
  // },
  add_refresh_subscribers(state, value) {
    state.refresh_subscribers.push(value);
  },
  clear_refresh_subscribers(state) {
    state.refresh_subscribers = [];
  },
  refreshing_token (state, value) {
    state.refreshing_token = value;
  },
  already_refreshed (state, value) {
    state.already_refreshed = value;
  },

  // inc_refresh_pool (state) {
  //   state.refresh_pool++;
  // },
  // dec_refresh_pool (state) {
  //   state.refresh_pool--;
  // }
};




// WEBPACK FOOTER //
// ./src/store/mutations.js